import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from 'src/app/app-config.service.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit {
  title = 'ng-uikit-pro-standard';
  isNavCollapse = false;
  visibleNav: boolean;

  constructor(
    public loadingService: LoadingService, 
    translate: TranslateService,
    private appconfig: AppConfigService) {
      this.appconfig.loadAppConfig()
    translate.setDefaultLang('en');
  }
  ngOnInit() {
  }

}
